import { getRequest, postRequest } from '@helpers/api';

/**
 * User login call
 * @param {string} email - Email address associated with user
 * @param {string} password - Password for given account
 * @param {string | number} [code] - 2FA authentication code
 * @param {boolean} [isResend] - Whether the call is a resend
 * @returns {Promise<unknown>}
 */
export const logIn = (email, password, code, isResend = false) => {
  let payload = { email, password, is_resend: isResend };
  if (code) payload = { ...payload, code };

  return postRequest('auth/login/', payload, {
    axiosOptions: { skipAuthRefresh: true },
  });
};

/**
 * Sets up two factor authentication for a given phone number
 * @param {string} phonePrefix - ISO country code
 * @param {string} phoneNumber - Phone number in question
 * @param {string} token - JWT token
 * @returns {Promise<unknown>}
 */
export const setupTwoFactorAuth = (phonePrefix, phoneNumber, token) =>
  postRequest(
    'auth/twoFactorPhoneNumber/',
    {
      phone_prefix: phonePrefix,
      phone_number: phoneNumber,
    },
    {
      additionalHeaders: { Authorization: `JWT ${token}` },
      axiosOptions: { noAuth: true, skipAuthRefresh: true },
    }
  );

/**
 * User logout call. Blacklists refresh token on POST.
 * @param {string} [refresh] - JWT token.
 * @returns {Promise<unknown>}
 */
export const logOut = (refresh = '') => postRequest('auth/logout/', { refresh });

/**
 * Verifies an OTP code against a given phone number
 * @deprecated
 * @param {string} phonePrefix iso country code
 * @param {sting} phoneNumber phone number
 * @param {string|number} code OTP code
 * @returns {Promise<unknown>}
 */
export const verifyTwoFactorAuthPhoneNumber = (phonePrefix, phoneNumber, code) =>
  postRequest('auth/twoFactorVerifyPhoneNumber/', {
    phone_prefix: phonePrefix,
    phone_number: phoneNumber,
    otp: code,
  });

/**
 * Requests an OTP token resend
 * @param {string} token JWT token
 * @returns {Promise<unknown>}
 */
export const resendTwoFactorAuthCode = token =>
  getRequest('auth/twoFactorResendCode/', null, {
    additionalHeaders: { Authorization: `JWT ${token}` },
    axiosOptions: { noAuth: true, skipAuthRefresh: true },
  });
